export const TYPES_CLASSES = {
  DEMO: 'DEMO',
  SAMPLE: 'SAMPLE',
}
